import { createDialogQueue } from "@rmwc/dialog";
import "@material/dialog/dist/mdc.dialog.css";
import "@material/button/dist/mdc.button.css";

export const queue = createDialogQueue();
